import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlPasswordProps extends ControlTemplateProps {
    
}

export const ControlPassword: React.FC<ControlPasswordProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="password" {...ComponentProps(props)} style={{ ...styles.password ?? styles.text ?? styles.input, ...props.style }} />        
    );
};